import { apiClient } from '@/services/ApiClient.js'

export default {
  getSalesChannels() {
    return apiClient
      .get('sales-channels')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getSalesChannelsByConfig(filter) {
    return apiClient
      .get('sales-channels/filter', {
        params: filter
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getSalesChannel(id) {
    return apiClient
      .get('sales-channels/' + id)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getProducts(id, query) {
    return apiClient
      .get('sales-channels/' + id + '/products', {
        params: query
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  attachProducts(id, products) {
    return apiClient
      .post('sales-channels/' + id + '/products', products)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  detachProducts(id, productId) {
    return apiClient
      .delete('sales-channels/' + id + '/products/' + productId)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getWorkflows(id) {
    return apiClient
      .get('sales-channels/' + id + '/workflows')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getWorkflow(sales_channel_id, workflow_job_id) {
    return apiClient
      .get('sales-channels/' + sales_channel_id + '/workflows/' + workflow_job_id)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  attachWorkflow(id, workflow) {
    return apiClient
      .post('sales-channels/' + id + '/workflows', workflow)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  detachWorkflow(id, workflowId) {
    return apiClient
      .delete('sales-channels/' + id + '/workflows/' + workflowId)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  updateWorkflow(id, params) {
    return apiClient
      .patch('sales-channels/' + id + '/workflows/' + params.workflow_job_id, params)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  sortWorkflows(id, params) {
    return apiClient
      .patch('sales-channels/' + id + '/sort-workflows', params)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }
}
